
export default {
  props: {
    post: {
      required: true,
      type: Object,
    },
    onShare: {
      required: false,
      type: Function
    }
  },
  mounted() {

  },
  data() {
    return {
      networks: [
        {
          network: 'email',
          icon: 'ci ci-email',
        },
        {
          network: 'facebook',
          icon: 'ci ci-facebook',
        },
        {
          network: 'twitter',
          icon: 'ci ci-twitter-x',
        },
        {
          network: 'whatsapp',
          icon: 'ci ci-whatsapp',
        },
      ],
      sharingInfo: {
        title: this.post.title,
        url: this.post.url,
        description: 'Leggi questo post su Communitì',
        // quote: 'My perfect quote',
        // hashtags: 'tag1,tag2',
        // twitterUser: 'POTUS',
        media: this.post.image
      }
    }
  },
}
